import { PropsWithChildren } from 'react'
import { Toaster } from '@/shared/ui/Toast'
import { AgreementModal } from '@/features/agreement/components/AgreementModal'
import { CookieAllowBar } from '@/features/agreement/components/CookieAllowBar'
import { Outlet } from 'react-router-dom'
import { useAddHtmlClass } from '@/shared/hooks/useAddHtmlClass.ts'
import { useAppHooks } from '@/shared/hooks/useAppHooks.ts'

export const AppLayout = ({ children }: PropsWithChildren) => {
  useAddHtmlClass('app-liquid-staking')
  useAppHooks()

  return (
    <>
      {children || <Outlet />}
      <Toaster />
      <AgreementModal />
      <CookieAllowBar />
    </>
  )
}
